
<iframe [style.height]="innerHeight" id="CertificatesIframe" style="width: 100%" [src]="url | safe" title="Invoice Certificates"></iframe>
